const template = document.createElement("template");
template.innerHTML = `<button part="button" type="button"><slot></slot></button>`;

export class MpButton extends HTMLElement {
  static observedAttributes = ["disabled", "kind"];
  readonly #button: HTMLButtonElement;

  constructor() {
    super();
    const root = this.attachShadow({ mode: "open" });
    root.append(template.content.cloneNode(true));
    this.#button = root.querySelector("button")!;
  }

  connectedCallback(): void {
    this.#sync();
  }

  attributeChangedCallback(): void {
    this.#sync();
  }

  override focus(options?: FocusOptions): void {
    this.#button.focus(options);
  }

  #sync(): void {
    this.#button.disabled = this.hasAttribute("disabled");
    this.#button.dataset.kind = this.getAttribute("kind") ?? "primary";
  }
}

customElements.define("mp-button", MpButton);
